import React from 'react';
import type { Toast as ToastData } from './hooks/useToast';

const LEVEL_STYLES: Record<string, { bg: string; border: string; color: string }> = {
  error:   { bg: '#fef2f2', border: '#f87171', color: '#991b1b' },
  warning: { bg: '#fffbeb', border: '#fbbf24', color: '#92400e' },
  success: { bg: '#f0fdf4', border: '#4ade80', color: '#166534' },
};

export const ToastContainer: React.FC<{
  toasts: ToastData[];
  onDismiss: (id: number) => void;
}> = ({ toasts, onDismiss }) => {
  if (toasts.length === 0) return null;

  return (
    <div
      aria-live="assertive"
      style={{
        position: 'fixed',
        top: '1rem',
        right: '1rem',
        zIndex: 9999,
        display: 'flex',
        flexDirection: 'column',
        gap: '0.5rem',
        maxWidth: '420px',
        width: '100%',
      }}
    >
      {toasts.map((t) => {
        const s = LEVEL_STYLES[t.level] || LEVEL_STYLES.error;
        return (
          <div
            key={t.id}
            role="alert"
            style={{
              background: s.bg,
              border: `1px solid ${s.border}`,
              color: s.color,
              borderRadius: '8px',
              padding: '12px 16px',
              fontSize: '0.95rem',
              lineHeight: 1.5,
              display: 'flex',
              alignItems: 'flex-start',
              gap: '8px',
              boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
              whiteSpace: 'pre-line',
            }}
          >
            <span style={{ flex: 1 }}>{t.message}</span>
            <button
              onClick={() => onDismiss(t.id)}
              aria-label="Dismiss"
              style={{
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                fontSize: '1.2rem',
                color: s.color,
                padding: 0,
                lineHeight: 1,
              }}
            >
              ×
            </button>
          </div>
        );
      })}
    </div>
  );
};
